/* eslint-disable complexity */
/* eslint max-params: ["error", 5] */

import './analysis.scss';
import React, {Component} from 'react';
import {FormattedMessage} from 'react-intl';
import KeyValuePair from '@deere/cps-it.warranty-model-factory/lib/key-value-pair';
import LabeledDateInput from '../../../../../../claim/shared/components/claim-fields/labeled-date-input';
import LabeledInput from '../../../../../../claim/shared/components/claim-fields/labeled-input';
import LabeledKeyValueDropDown from '../../../../../../claim/shared/components/claim-fields/labeled-key-value-dropdown';
import LabeledString from '../../../../../../shared/components/labeled-string';
import LabeledTextArea from '../../../../../../claim/shared/components/claim-fields/labeled-text-area';
import PropTypes from 'prop-types';
import RgaDetails from '../../../../../rga-search-results/state/rga-details';
import Security from '@deere/cps-it.warranty-model-factory/lib/security';
import WarrantyLoadingIndicator from '../../../../../../shared/components/warranty-loading-indicator';
import {buildDate} from '../../../../../../shared/services/build-date';
import {findValueKeyPair} from '../../../../../shared/services/rga-utils';
import {hasAccess} from '../../../../../../shared/services/security';

const keyValueList = [
    {key: 'PART_REQUEST_STATUS', value: 'PART_REQUEST_STATUS'},
    {key: 'REQUEST_FACTORY', value: 'REQUEST_FACTORY'},
    {key: 'LOG_NUMBER(S)', value: 'LOG_NUMBER(S)'},
    {key: 'DTAC_CASE_NUMBER', value: 'DTAC_CASE_NUMBER'},
    {key: 'NCCA_CAR_NUMBER', value: 'NCCA_CAR_NUMBER'}
];

function toggleLogHistory() {

    this.setState(prevState => ({
        isLogHistory: !prevState.isLogHistory
    }));

}

function onChangeAnalysisFieldValue(propertyName, props, value) {

    props.actions.updateRgaAnalysisValues(propertyName, value);

}

function onChangeAnalysisDropDownValue(propertyName, props, event) {

    props.actions.updateRgaAnalysisValues(propertyName, event.target.value);

}

function onSave() {

    this.actions.postRgaAnalysisValues(this.rgaDetails);

}

function onCancel() {

    this.actions.getRgaDetails(this.rgaDetails);

}
class Analysis extends Component {
    constructor(props) {

        super(props);
        this.state = {
            isLogHistory: true,
            showDrodown: false
        };

    }

    render() {

        const {rgaDetails} = this.props;

        return (
            <section className='rga-recalled-form'>
                <WarrantyLoadingIndicator isLoading={this.props.busyCounter > 0}/>
                <div className='row'>
                    <LabeledInput
                        className={this.props.security.role === 'RGA_USER' ? 'disabled-field-analysis' : 'part-request'}
                        isEditable={true}
                        label={<span>{'Analyst'}<span style={{color: '#bd2e28', padding: '5px'}}>{'*'}</span></span>}
                        maxLength={15}
                        onChange={onChangeAnalysisFieldValue.bind(event, 'analystId', this.props)}
                        tabIndex='1'
                        value={rgaDetails.analystId}
                    />
                    <LabeledKeyValueDropDown
                        className={this.props.security.role === 'RGA_USER' ? 'disabled-field-analysis' : 'part-request'}
                        isEditable={true}
                        isValid={true}
                        label='Analysis Status'
                        list={this.props.analysisStatus}
                        onChange={onChangeAnalysisDropDownValue.bind(event, 'analysisStatus', this.props)}
                        selectedValue={findValueKeyPair(this.props.analysisStatus, rgaDetails.analysisStatus)}
                        tabIndex='2'
                    />
                    <LabeledDateInput
                        className={this.props.security.role === 'RGA_USER' ? 'disabled-field-analysis' : 'part-request'}
                        date={rgaDetails.analysisDate}
                        isEditable={true}
                        isValid={true}
                        label='Analyzed'
                        onDateChange={onChangeAnalysisFieldValue.bind(event, 'analysisDate', this.props)}
                        tabIndex='3'
                    />
                </div>
                <div className='row'>
                    <LabeledInput
                        className={this.props.security.role === 'RGA_USER' ? 'disabled-field-analysis' : 'part-request'}
                        isEditable={true}
                        label='Returned Part Number'
                        maxLength={15}
                        onChange={onChangeAnalysisFieldValue.bind(event, 'returnedPartNumber', this.props)}
                        tabIndex='4'
                        value={rgaDetails.returnedPartNumber}
                    />
                    <LabeledInput
                        className={this.props.security.role === 'RGA_USER' ? 'disabled-field-analysis' : 'part-request'}
                        isEditable={true}
                        label='Quantity Received'
                        maxLength={15}
                        onChange={onChangeAnalysisFieldValue.bind(event, 'returnedPartQuantity', this.props)}
                        tabIndex='4'
                        value={rgaDetails.returnedPartQuantity}
                    />
                    { this.props.security.role === 'RGA_USER' ?
                        <LabeledDateInput
                            className={'disabled-field-analysis'}
                            date={rgaDetails.partReceiveDate}
                            isEditable={true}
                            isValid={true}
                            label='Part Received'
                            onDateChange={onChangeAnalysisFieldValue.bind(event, 'partReceiveDate', this.props)}
                            tabIndex='6'
                        /> :
                            <LabeledDateInput
                                className={((!hasAccess(this.props.security, 'RECALLED_PARTS', 'RECALLED_PARTS_ADMIN')) && hasAccess(this.props.security, 'RECALLED_PARTS', 'RECALLED_PARTS_EDIT')) ? 'disabled-field-analysis' : 'part-request'}
                                date={rgaDetails.partReceiveDate}
                                isEditable={true}
                                isValid={true}
                                label='Part Received'
                                onDateChange={onChangeAnalysisFieldValue.bind(event, 'partReceiveDate', this.props)}
                                tabIndex='6'
                            />}
                </div>
                <div className='row'>
                    {this.state.showDrodown &&
                    <LabeledInput
                        className='part-request'
                        isEditable={true}
                        label='Platform'
                        maxLength={15}
                        onChange={onChangeAnalysisFieldValue.bind(event, 'platform', this.props)}
                        tabIndex='7'
                        value={rgaDetails.platform}
                    />}
                    <LabeledInput
                        className={this.props.security.role === 'RGA_USER' ? 'disabled-field-analysis' : 'part-request'}
                        isEditable={true}
                        label='Sub System'
                        maxLength={15}
                        onChange={onChangeAnalysisFieldValue.bind(event, 'subSystem', this.props)}
                        tabIndex='8'
                        value={rgaDetails.subSystem}
                    />
                    <LabeledInput
                        className={this.props.security.role === 'RGA_USER' ? 'disabled-field-analysis' : 'part-request'}
                        isEditable={true}
                        label='NCCA CAR Number'
                        onChange={onChangeAnalysisFieldValue.bind(event, 'nccaCarNo', this.props)}
                        tabIndex='10'
                        value={rgaDetails.nccaCarNo}
                    />
                    <LabeledInput
                        className={this.props.security.role === 'RGA_USER' ? 'disabled-field-analysis' : 'part-request'}
                        isEditable={true}
                        label='Supplier'
                        maxLength={15}
                        onChange={onChangeAnalysisFieldValue.bind(event, 'supplier', this.props)}
                        tabIndex='12'
                        value={rgaDetails.supplier}
                    />
                    {this.state.showDrodown &&
                    <LabeledInput
                        className={this.props.security.role === 'RGA_USER' ? 'disabled-field-analysis' : 'part-request'}
                        isEditable={true}
                        label='Family'
                        maxLength={15}
                        onChange={onChangeAnalysisFieldValue.bind(event, 'family', this.props)}
                        tabIndex='9'
                        value={rgaDetails.family}
                    />}
                </div>
                <div className='row'>
                    <LabeledKeyValueDropDown
                        className={this.props.security.role === 'RGA_USER' ? 'disabled-field-analysis' : 'part-request'}
                        isEditable={true}
                        isValid={true}
                        label='Responsible Unit'
                        list={this.props.rgaUnits}
                        onChange={onChangeAnalysisDropDownValue.bind(event, 'responsibleUnit', this.props)}
                        selectedValue={findValueKeyPair(this.props.rgaUnits, rgaDetails.responsibleUnit)}
                        tabIndex='16'
                    />
                    <LabeledInput
                        className={this.props.security.role === 'RGA_USER' ? 'disabled-field-analysis' : 'part-request'}
                        isEditable={true}
                        label='Log Number'
                        maxLength={15}
                        onChange={onChangeAnalysisFieldValue.bind(event, 'logNumber', this.props)}
                        tabIndex='21'
                        value={rgaDetails.logNumber}
                    />
                </div>
                <div className='row'>
                    {this.state.showDrodown &&
                    <LabeledDateInput
                        className={this.props.security.role === 'RGA_USER' ? 'disabled-field-analysis' : 'part-request'}
                        date={rgaDetails.manufacturedDate}
                        isEditable={true}
                        isValid={true}
                        label='Manufactured'
                        onDateChange={onChangeAnalysisFieldValue.bind(event, 'manufacturedDate', this.props)}
                        tabIndex='14'
                    />}
                    {this.state.showDrodown &&
                    <LabeledInput
                        className={this.props.security.role === 'RGA_USER' ? 'disabled-field-analysis' : 'part-request'}
                        isEditable={true}
                        label='Manufacturing code'
                        maxLength={15}
                        onChange={onChangeAnalysisFieldValue.bind(event, 'manufacturingCode', this.props)}
                        tabIndex='15'
                        value={rgaDetails.manufacturingCode}
                    />}
                </div>
                <div className='row'>
                    {this.state.showDrodown &&
                        <LabeledKeyValueDropDown
                            className={this.props.security.role === 'RGA_USER' ? 'disabled-field-analysis' : 'part-request'}
                            isEditable={true}
                            isValid={true}
                            label='Part Group'
                            list={keyValueList}
                            onChange={null}
                            selectedValue={{key: '', value: ''}}
                            tabIndex='17'
                        />
                        }
                    {this.state.showDrodown &&
                        <LabeledKeyValueDropDown
                            className={this.props.security.role === 'RGA_USER' ? 'disabled-field-analysis' : 'part-request'}
                            isEditable={true}
                            isValid={true}
                            label='Analysis Failure Mode'
                            list={keyValueList}
                            onChange={null}
                            selectedValue={{key: '', value: ''}}
                            tabIndex='18'
                        />}
                </div>
                <div className='row'>
                    {this.state.showDrodown &&
                    <LabeledKeyValueDropDown
                        className={this.props.security.role === 'RGA_USER' ? 'disabled-field-analysis' : 'part-request'}
                        isEditable={true}
                        isValid={true}
                        label='Failure Mechanism/RCA'
                        list={keyValueList}
                        onChange={null}
                        selectedValue={{key: '', value: ''}}
                        tabIndex='19'
                    />}
                    {this.state.showDrodown &&
                    <LabeledKeyValueDropDown
                        className={this.props.security.role === 'RGA_USER' ? 'disabled-field-analysis' : 'part-request'}
                        isEditable={true}
                        isValid={true}
                        label='Responsible Group'
                        list={keyValueList}
                        onChange={null}
                        selectedValue={{key: '', value: ''}}
                        tabIndex='20'
                    /> }
                </div>
                <div className='row'>
                    <LabeledTextArea
                        className={this.props.security.role === 'RGA_USER' ? 'disabled-text-area-analysis' : 'Text-area'}
                        isEditable={true}
                        label='Attention Line'
                        onChange={onChangeAnalysisFieldValue.bind(event, 'attentionLine', this.props)}
                        tabIndex='22'
                        value={rgaDetails.attentionLine}
                    />
                </div>
                <div className='row'>
                    <LabeledTextArea
                        className={this.props.security.role === 'RGA_USER' ? 'disabled-text-area-analysis' : 'Text-area'}
                        isEditable={true}
                        label='Failure Description'
                        onChange={onChangeAnalysisFieldValue.bind(event, 'failureDescription', this.props)}
                        tabIndex='23'
                        value={rgaDetails.failureDescription}
                    />
                </div>
                <div className='row'>
                    <LabeledTextArea
                        className={this.props.security.role === 'RGA_USER' ? 'disabled-text-area-analysis' : 'Text-area'}
                        isEditable={true}
                        label='Findings'
                        onChange={onChangeAnalysisFieldValue.bind(event, 'findings', this.props)}
                        tabIndex='24'
                        value={rgaDetails.findings}
                    />
                </div>
                {this.state.isLogHistory ?
                    <div className='row'>
                        <LabeledString
                            className='part-request'
                            data={buildDate(rgaDetails.createdTimestamp)}
                            label='Created Date Time'
                        />
                        <LabeledString
                            className='part-request'
                            data={buildDate(rgaDetails.updatedTimestamp)}
                            label='Last Modified'
                        />
                        <LabeledString
                            className='part-request'
                            data={rgaDetails.createdBy}
                            label='Created By'
                        />
                        <LabeledString
                            className='part-request'
                            data={rgaDetails.updatedBy}
                            label='Updated By'
                        />
                    </div> : null
                }
                <div className='row'>
                    <button
                        className='secondary'
                        onClick={toggleLogHistory.bind(this)}
                    >
                        <FormattedMessage id='Log History'/>
                    </button>
                </div>
                <section className='button-group recalled-button-group'>
                    <button
                        className='secondary'
                        onClick={onCancel.bind(this.props)}
                    >
                        <FormattedMessage id='CANCEL'/>
                    </button>
                    <button
                        className='primary'
                        disabled={rgaDetails.analystId === '' || this.props.security.role === 'RGA_USER'}
                        onClick={onSave.bind(this.props)}
                    >
                        <FormattedMessage id='SAVE'/>
                    </button>
                </section>
            </section>
        );

    }
}

Analysis.displayName = 'Analysis';
Analysis.propTypes = {
    actions: PropTypes.object.isRequired,
    analysisStatus: PropTypes.instanceOf(KeyValuePair).isRequired,
    busyCounter: PropTypes.number.isRequired,
    partReqStatus: PropTypes.instanceOf(KeyValuePair).isRequired,
    rgaDetails: PropTypes.instanceOf(RgaDetails).isRequired,
    rgaUnits: PropTypes.arrayOf(PropTypes.instanceOf(KeyValuePair)).isRequired,
    security: PropTypes.instanceOf(Security).isRequired
};

export default Analysis;



// WEBPACK FOOTER //
// ./src/rga/recalled-part-analysis/components/returned-part-information/recalled-part-tab/components/analysis.js